import React from 'react';
import type { CallToActionModule as CallToActionModuleData } from 'libs/sanity/types/generated';
import CallToActionBlock from 'libs/sanity/content/Blocks/CallToActionBlock';

interface CallToActionModuleProps {
    data?: CallToActionModuleData;
    imageLoading?: 'eager' | 'lazy';
}

const CallToActionModule: React.FC<CallToActionModuleProps> = (props) => {
    const { data: moduleData, imageLoading = 'lazy' } = props;

    const blockData = moduleData?.block || moduleData;
    if (!blockData) {
        return null;
    }

    return <CallToActionBlock data={{ ...blockData, layout: 'fullWidth' }} theme="dark" imageLoading={imageLoading} />;
};
export default CallToActionModule;
